import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useEffect, useState } from 'react';
import { api } from '../../api';
import { GateType } from '../../schema/gate';

interface GateTypeFromInputProps {
  required?: boolean;
  value?: number | null;
  onChange?: (value: number | null) => void;
  canSelectAll?: boolean;
}

const GateTypeFromInput: React.FC<GateTypeFromInputProps> = ({
  required,
  value,
  onChange,
  canSelectAll
}: GateTypeFromInputProps) => {
  const [gateTypeList, setGateTypeList] = useState<GateType[]>([]);
  useEffect(() => {
    api.get<GateType[]>(`/gate_type`).then((res) => {
      const { data } = res;
      setGateTypeList(data);
    });
  }, []);

  return (
    <FormControl fullWidth>
      <InputLabel>{`ประเภทประตู${required ? ' *' : ''}`}</InputLabel>
      <Select
        label={`ประเภทประตู${required ? ' *' : ''}`}
        variant="outlined"
        onChange={(e) => {
          if (onChange) {
            const parsed = parseInt(e.target.value);
            if (isNaN(parsed)) {
              onChange(null);
              return;
            }
            onChange(parsed);
          }
        }}
        value={value != null ? `${value}` : ''}
        autoComplete="off"
        required={required}
      >
        {canSelectAll ? <MenuItem value="">ทั้งหมด</MenuItem> : null}
        {gateTypeList.map((data, index) => (
          <MenuItem key={index} value={`${data.id}`}>
            {data.type_name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default GateTypeFromInput;
